import React, { useState } from "react";
import * as XLSX from "xlsx";
import { useAppV3 } from "contexts/v3/BookingContextV3";
import Swal from "sweetalert2";

const ExportExcel = ({ reservationDate }) => {
  const { bookings } = useAppV3();
  const [isLoading, setIsLoading] = useState(false); // 🔹 State untuk loading

  const handleExport = () => {
    if (!bookings || !bookings.data || bookings.data.length === 0) {
      Swal.fire("Error", "Data not found", "error");
      return;
    }

    // 🔹 Tampilkan loading Swal
    Swal.fire({
      title: "Exporting...",
      text: "Please wait while the file is being processed...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    setIsLoading(true);

    setTimeout(() => {
      try {
        // 🔹 Filter data hanya untuk tanggal yang dipilih
        const filteredData = bookings.data.filter(
          (booking) => booking.reservation_date === reservationDate
        );

        if (filteredData.length === 0) {
          Swal.fire("Error", `No data found for ${reservationDate}`, "warning");
          setIsLoading(false);
          return;
        }

        // 🔹 Tambahkan judul laporan di baris pertama
        const title = [`Booking Report: ${reservationDate}`];

        // 🔹 Format data yang akan diekspor
        const dataToExport = filteredData.map((booking) => ({
          "Kode Booking": booking.code,
                                // ({activity.qty}x) : {activity.activity} : Rp.{formatPrice(activity.price)}
          // Aktivitas: booking.activities.map((a) => `${a.activity} (${a.qty})`).join(", "), 
          Aktivitas: booking.activities.map((a) => `(${a.qty}x) : ${a.activity} : Rp.${parseInt(a.price).toLocaleString("id-ID")}`).join("| "),
          "Nama Tamu": booking.guest_name,
          "Driver": booking.driver || "-",
          "Hotel": booking.customer?.nationality || "-",
          Status: booking.status,
          Agent: booking.agent?.name || "N/A",
          "Jumlah Pax": booking.guest_pax,
          "Total Harga": `Rp. ${parseInt(booking.total_price).toLocaleString("id-ID")}`,
          "Catatan Pembayaran": booking.payment_note || "-",
          "Tanggal Reservasi": booking.reservation_date,
        }));

        // 🔹 Buat file Excel
        const worksheet = XLSX.utils.json_to_sheet(dataToExport, { origin: "A2" });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, `Report_${reservationDate}`);

        // 🔹 Tambahkan judul di baris pertama (A1)
        XLSX.utils.sheet_add_aoa(worksheet, [title], { origin: "A1" });

        // 🔹 Save file using Blob and anchor with download attribute for better Android compatibility
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Booking_Report_${reservationDate}.xlsx`);
        document.body.appendChild(link);
        link.click();

        // 🔹 Cleanup
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);

        // 🔹 Tampilkan notifikasi sukses
        Swal.fire("Success!", `File successfully exported!`, "success");
      } catch (error) {
        console.error("Export Excel Error:", error);
        Swal.fire("Error", "An error occurred while exporting the data.", "error");
      } finally {
        setIsLoading(false);
      }
    }, 1000); // Simulasi delay agar loading terlihat
  };

  return (
    <button
      className="btn btn-outline-primary"
      onClick={handleExport}
      disabled={isLoading} // 🔹 Disable tombol saat loading
    >
      {isLoading ? (
        <>
          <span className="spinner-border spinner-border-sm me-2" role="status"></span>
          Exporting...
        </>
      ) : (
        <>📥 Export Excel ({reservationDate})</>
      )}
    </button>
  );
};

export default ExportExcel;
